import sites from "config/sites"

export function getSiteByLocale(locale) {
    return sites[locale]
}

export function getSiteByHost(host) {
    const hostname = host.split(":")[0]

    // 1. fullDomain match (with or without www. / dev. / dev2. prefix)
    const hostNormalized = hostname.replace(/^(?:www|dev\d?)\./, "")
    for (const [, site] of Object.entries(sites)) {
        if (!site.fullDomain) continue
        if (site.fullDomain.replace(/^(?:www|dev\d?)\./, "") === hostNormalized) return site
    }

    // 2. crfconferences subdomain — {locale} or dev[2]-{locale}
    const match = hostname.match(/^(?:dev\d?-)?(.+?)\.crfconferences\.(?:com|lcl)$/)
    if (match) return sites[match[1]]

    // 3. local dev fallback
    return sites[process.env.DEFAULT_LOCALE]
}

export function getSiteLocaleByHost(host) {
    const hostname = host.split(":")[0]

    // 1. fullDomain match (with or without www. / dev. / dev2. prefix)
    const hostNormalized = hostname.replace(/^(?:www|dev\d?)\./, "")
    for (const [locale, site] of Object.entries(sites)) {
        if (!site.fullDomain) continue
        if (site.fullDomain.replace(/^(?:www|dev\d?)\./, "") === hostNormalized) return locale
    }

    // 2. crfconferences subdomain — {locale} or dev[2]-{locale}
    const match = hostname.match(/^(?:dev\d?-)?(.+?)\.crfconferences\.(?:com|lcl)$/)
    if (match) return match[1]

    // 3. local dev fallback
    return process.env.DEFAULT_LOCALE
}

export function getSiteIdByLocale(locale) {
    return sites[locale].craftId
}

export function getEmmaMeetingIdByLocale(locale) {
    return sites[locale].emmaId
}
